import { apiForPrivate } from '.';
import { INCIDENT_ENDPOINT } from '../../config/ap';

const apiIncidents = apiForPrivate.injectEndpoints({

    overrideExisting: true,
    
    endpoints: build => ({
        getLatestIncidents: build.query({
            query: () => ({
                url: `${INCIDENT_ENDPOINT.INCIDENTS}/latest`,
            })
        })
    })
});

export const {
    useGetLatestIncidentsQuery
} = apiIncidents;